import type {ReactElement} from 'react';
import {ColorControl} from '@FormMakerReact/layout/form-maker-right-panel/controls/color-control/color-control';
import {DEFAULT_BG_COLOR} from '@FormMakerReact/layout/form-maker-right-panel/sectors/submit-button-sector/submit-button-sector.types';
import type {SubmitButtonBgColorControlProps} from './submit-button-bg-color-control.types';

export function SubmitButtonBgColorControl({component}: SubmitButtonBgColorControlProps): ReactElement {
  return (
    <ColorControl
      component={component}
      property="background-color"
      labelKey="pmwjs_form_maker_control_bg_color_label"
      pickAriaKey="pmwjs_form_maker_control_bg_color_pick"
      clearAriaKey="pmwjs_form_maker_control_bg_color_clear"
      defaultColor={DEFAULT_BG_COLOR}
    />
  );
}
